import type { BarNetwork, Holiday, MyClock, PaidWindow, Punch, PunchTimes, StaffNote, TimesheetWeek } from '../../types/timeClock'
import { request, requestBlob } from './http'

const json = (method: string, body?: unknown): RequestInit => ({ method, body: body === undefined ? undefined : JSON.stringify(body) })

export const getMyClock = () => request<MyClock>('/time-clock/me')

export const clockIn = (reason: string | null) => request<MyClock>('/time-clock/in', json('POST', { reason }))

export const clockOut = () => request<MyClock>('/time-clock/out', json('POST'))

export const getBarNetwork = () => request<BarNetwork>('/time-clock/network')

export const confirmBarNetwork = () => request<BarNetwork>('/time-clock/network', json('POST'))

export const getTimesheetWeek = (weekStart: string | null) =>
	request<TimesheetWeek>(weekStart ? `/time-clock/week?week=${weekStart}` : '/time-clock/week')

export const approvePunch = ({ id, paid }: { id: number; paid: PaidWindow }) =>
	request<Punch>(`/time-clock/punches/${id}/approve`, json('POST', { paid }))

export const editPunch = ({ id, times }: { id: number; times: PunchTimes }) =>
	request<Punch>(`/time-clock/punches/${id}`, json('PATCH', times))

export const createPunch = (body: PunchTimes & { user_id: string }) => request<Punch>('/time-clock/punches', json('POST', body))

export const deletePunch = (id: number) => request<{ id: number }>(`/time-clock/punches/${id}`, json('DELETE'))

export const listHolidays = () => request<Holiday[]>('/time-clock/holidays')

export const saveHoliday = (holiday: Holiday) => request<Holiday[]>('/time-clock/holidays', json('PUT', holiday))

export const deleteHoliday = (date: string) => request<Holiday[]>(`/time-clock/holidays/${date}`, json('DELETE'))

export const downloadMonthHours = (month: string) => requestBlob(`/time-clock/export?month=${month}`)

export const listStaffNotes = (userId: string) => request<StaffNote[]>(`/admin/staff-notes?user_id=${encodeURIComponent(userId)}`)

export const addStaffNote = (note: { user_id: string; body: string }) => request<StaffNote[]>('/admin/staff-notes', json('POST', note))

export const deleteStaffNote = (id: number) => request<StaffNote[]>(`/admin/staff-notes/${id}`, json('DELETE'))
